import { Clock16Regular } from '@/components/Icon'
import styles from './createdTriggerCard.module.scss'

/**
 * @param {{
 *   title: string,
 *   schedule: string,
 *   label?: string,
 * }} props
 */
export default function CreatedTriggerCard({
  title,
  schedule,
  label = 'Created Trigger',
}) {
  return (
    <div className={styles.root} role="status" aria-live="polite">
      <span className={styles.label}>{label}</span>
      <div className={styles.body}>
        <span className={styles.iconWrap} aria-hidden>
          <Clock16Regular className={styles.icon} />
        </span>
        <div className={styles.content}>
          <div className={styles.titleRow}>
            <p className={styles.title}>{title}</p>
            <span className={styles.statusDot} aria-hidden />
          </div>
          <p className={styles.schedule}>{schedule}</p>
        </div>
      </div>
    </div>
  )
}
